import SeoReports from './SeoReports.container';

export default SeoReports;
